import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FormCard } from "../../../components/ui/form";
import RowAction, { RowActions } from "../../../components/ui/RowAction";
import { IconPen } from "../../../components/ui/icons";
import { OrderSkeleton } from "../../../components/spinner/loader";
import { tokens } from "../../../theme";

/*
  Grilla en vez de tabla: son cuatro datos por fila y así se puede colapsar a
  dos columnas en teléfono sin scroll horizontal.
*/
const GRID = {
  display: "grid",
  gridTemplateColumns: { xs: "80px minmax(0, 1fr) 44px", md: "110px 150px minmax(0, 1fr) 64px" },
  alignItems: "center",
  gap: { xs: "8px", md: "12px" },
};

const FinishedOrders = ({ finishedOrders, client, isLoading = false }) => {
  const navigate = useNavigate();

  return (
    <FormCard
      title="Órdenes terminadas"
      subtitle={
        isLoading
          ? "Cargando…"
          : `${finishedOrders?.length || 0} ${
              finishedOrders?.length === 1 ? "orden" : "órdenes"
            } esperando revisión`
      }
      sx={{ width: "100%", minWidth: 0 }}
    >
      {isLoading ? (
        <OrderSkeleton />
      ) : !finishedOrders?.length ? (
        <Typography sx={{ fontSize: "12.5px", color: tokens.ink3, paddingY: "10px" }}>
          Este cliente no tiene órdenes terminadas pendientes.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <Box
            sx={{
              ...GRID,
              paddingBottom: "8px",
              borderBottom: `1px solid ${tokens.border}`,
              "& > *": {
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: tokens.ink3,
              },
            }}
          >
            <Typography>Orden</Typography>
            <Typography sx={{ display: { xs: "none", md: "block" } }}>Fecha</Typography>
            <Typography>Descripción</Typography>
            <Typography sx={{ textAlign: "right" }}>Acciones</Typography>
          </Box>

          {finishedOrders.map((item) => {
            const isPlaceholder = item.description === "Cargando...";
            return (
              <Box
                key={item.orderId}
                sx={{
                  ...GRID,
                  paddingY: "10px",
                  borderBottom: `1px solid ${tokens.borderSoft}`,
                  "&:last-of-type": { borderBottom: "none" },
                }}
              >
                <Typography sx={{ fontSize: "13px", fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
                  #{item.orderId}
                </Typography>
                <Typography
                  sx={{
                    display: { xs: "none", md: "block" },
                    fontSize: "12.5px",
                    color: tokens.ink2,
                    fontVariantNumeric: "tabular-nums",
                  }}
                >
                  {item.date}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12.5px",
                    minWidth: 0,
                    color: isPlaceholder ? tokens.ink4 : tokens.ink,
                    fontStyle: isPlaceholder ? "italic" : "normal",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={item.description}
                >
                  {item.description}
                </Typography>
                <RowActions>
                  {!isPlaceholder && (
                    <RowAction
                      icon={IconPen}
                      title="Editar orden"
                      onClick={() => {
                        navigate("/order-details-form", {
                          state: { order: { ...item, client: client } },
                        });
                      }}
                    />
                  )}
                </RowActions>
              </Box>
            );
          })}
        </Box>
      )}
    </FormCard>
  );
};

export default FinishedOrders;
